'use client'

import { Heading, type HeadingProps } from '../../heading'

export const InfoModalTitle = (props: HeadingProps) => {
  return <Heading className="text-center" fontSize="4xl" {...props} />
}
